import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import FormPage from './components/FormPage';
import SuccessPage from './components/SuccessPage';
import PaymentStatus from "./components/PaymentStatus";

import { PrivacyPolicy, TermsConditions, RefundPolicy, ContactUs } from './components/Policies';

function App() {
  return (
    <Router>
      <Routes>
        {/* Existing Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/workshop" element={<LandingPage />} />
        <Route path="/workshop/" element={<LandingPage />} />
        <Route path="/join" element={<FormPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/payment-success" element={<PaymentStatus />} />

        {/* 🟢 New Policy Routes for Cashfree Compliance */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    </Router>
  );
}

export default App;
